import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { selectCompareItems } from '../../redux/selectors/compareSelector';
import {
  clearCompare,
  toggleCompareItem,
} from '../../redux/slices/compareSlice';
import { updatePrice } from '../../utils/helper';
import { addItemToCart } from '../../redux/slices/cartSlice';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';

const CompareMain = () => {
  const compareProducts = useSelector(selectCompareItems); // selector to get all products in compareItems
  const dispatch = useDispatch();

  // Dispatch the action to add the item to cart with the adjusted price based on badge title using helper function
  const handleAddToCart = (product) => {
    dispatch(
      addItemToCart({
        product: product,
      })
    );
  };

  // Dispatch the action to remove product from compare
  const handleRemove = (product) => {
    dispatch(toggleCompareItem(product));
  };

  // Dispatch the action to remove all products from compare
  const handleClear = () => {
    const confirmed = window.confirm(
      'Are you sure you want to clear the comparison?'
    );
    if (confirmed) {
      dispatch(clearCompare());
      toast.success('Comparison cleared successfully!', {
        position: 'top-center',
      });
    }
  };

  return (
    <main>
      <Breadcrumb title="Compare" />

      {compareProducts.length === 0 ? (
        <div className="it-error-content text-center pt-120 pb-100">
          <h5
            className="it-error-title wow animate__fadeInUp pb-30"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            No Product to Compare
          </h5>

          <Link
            className="it-btn-theme wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
            to="/shop-sidebar"
          >
            <Button btnText="Back To Shop" />
          </Link>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center pt-60 pb-80">
          <div className="container compare-container ">
            <table className="compare-table">
              <thead>
                <tr>
                  <th>Product</th>
                  {compareProducts.map((product) => (
                    <th key={product.id}>{product.title}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Image</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      <img
                        src={product.thumbnail}
                        alt=""
                        className="compare-image"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Description</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      {product.description
                        ? product.description
                        : ` Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Illum assumenda, explicabo incidunt excepturi dolore sint
                  quisquam placeat blanditiis consectetur cupiditate pariatur
                  aliquam deleniti, aperiam ducimus porro et. Nemo, a cumque!`}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Price</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      {product?.badgeTitle?.includes('%') && (
                        <strong>
                          <del>${product.price.toFixed(2)}</del>{' '}
                        </strong>
                      )}
                      <strong>
                        ${Math.round(updatePrice(product)).toFixed(2)}
                      </strong>
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Discount</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      {product.badgeTitle?.includes('%')
                        ? product.badgeTitle
                        : 'New'}
                    </td>
                  ))}
                </tr>

                <tr>
                  <td>Rating</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      <i className="fa-solid fa-star text-warning"></i>
                      <i className="fa-solid fa-star text-warning"></i>
                      <i className="fa-solid fa-star text-warning"></i>
                      <i className="fa-solid fa-star text-warning"></i>
                      <i className="fa-solid fa-star text-warning"></i> (
                      {product.rating})
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Add To Cart</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      <Link
                        to="#"
                        className="it-btn-theme text-white"
                        onClick={() => handleAddToCart(product)}
                      >
                        <Button btnText="Add To Cart" />
                      </Link>
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Remove</td>
                  {compareProducts.map((product) => (
                    <td key={product.id}>
                      <button
                        type="button"
                        onClick={() => handleRemove(product)}
                      >
                        <i className="fa fa-times"></i>
                      </button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
          <button className="it-btn-theme mt-40" onClick={() => handleClear()}>
            <Button btnText="Clear Comparison" />
          </button>
        </div>
      )}
    </main>
  );
};

export default CompareMain;
